import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
import { monitoringPolling } from "./polling";

export function useOverviewPhones() {
  const phones = useQuery({ queryKey: ["device-queues", "live"], queryFn: api.phoneWorkspace, refetchInterval: monitoringPolling(3000) });
  const connection = useQuery({ queryKey: ["overview-phone-connection"], queryFn: api.mobileProviderStatus, refetchInterval: monitoringPolling(10_000) });
  const error = phones.error || connection.error || (connection.data && !connection.data.ready ? new Error(connection.data.message || "手机连接服务不可用") : null);
  return {
    phones: !error ? (phones.data || []).filter(phone => phone.status === "online") : [],
    allPhones: !error ? phones.data || [] : [],
    isLoading: phones.isLoading || connection.isLoading,
    error,
    retry: () => Promise.all([phones.refetch(), connection.refetch()]),
  };
}
